import store from "../store/index";

const SELECTORS = {
  btn: ".js-alert-btn",
};

const CLASSES = {
  hidden: "hidden",
};

class Alert {
  constructor(context) {
    this.context = context;
  }

  init() {
    this.alertBtn = this.context.querySelector(SELECTORS.btn);

    this.subscribe();
  }

  dispatchHeight(alertHeight) {
    store.dispatch("setAlertHeight", { alertHeight });
  }

  subscribe() {
    if (this.alertBtn !== null) {
      this.alertBtn.addEventListener("click", (event) => {
        this.dispatchHeight(-this.context.offsetHeight);
        this.hideAlert();
      });
    }

    window.addEventListener("load", (event) => {
      this.dispatchHeight(this.context.offsetHeight);
    });
  }

  hideAlert() {
    this.context.classList.toggle(CLASSES.hidden, true);

    return this;
  }
}

export { Alert };
